var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.595,
    viewBox: "0 0 16 15.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-arrow-left",
    d: "M9.194,17.2,8.4,17.99a.854.854,0,0,1-1.211,0L.248,11.052a.854.854,0,0,1,0-1.211L7.19,2.9A.854.854,0,0,1,8.4,2.9l.793.793a.858.858,0,0,1-.014,1.225l-4.3,4.1H15.139A.855.855,0,0,1,16,9.873v1.143a.855.855,0,0,1-.857.857H4.876l4.3,4.1A.852.852,0,0,1,9.194,17.2Z",
    transform: "translate(0.004 -2.647)",
    fill: "#daab3a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon-arrow-left.2d39a0c81696d264ec6b6e766e05278c.svg";
export { ForwardRef as ReactComponent };